import { NetworkMode, QueryClient } from '@tanstack/react-query';

const defaultOptions = {
  queries: {
    useErrorBoundary: true,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchInterval: 86400000,
    gcTime: 86400000,
    staleTime: 86400000,
    retry: false,
    networkMode: 'always' as NetworkMode,
  },
};

export const ReactQueryInstance = new QueryClient({
  defaultOptions,
});

export default ReactQueryInstance;
